import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface PanAlreadySearchedData {
  checked: boolean;
  creditsUsed: number;
  searchId: number;
  timestamp: string;
  transactionId: string;
}

export type PanDialogAction = 'view_previous' | 'fresh_search' | 'cancel';

@Component({
  selector: 'app-pan-already-searched-dialog',
  templateUrl: './pan-already-searched-dialog.component.html',
  styleUrls: ['./pan-already-searched-dialog.component.scss']
})
export class PanAlreadySearchedDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<PanAlreadySearchedDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: PanAlreadySearchedData
  ) { }

  get formattedDate(): string {
    const date = new Date(this.data.timestamp);
    return date.toLocaleString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: true
    });
  }

  onViewPreviousReport(): void {
    this.dialogRef.close('view_previous' as PanDialogAction);
  }

  onFreshSearch(): void {
    this.dialogRef.close('fresh_search' as PanDialogAction);
  }

  onCancel(): void {
    this.dialogRef.close('cancel' as PanDialogAction);
  }
}

